import React, { useMemo, useState } from 'react';
import {
  Button,
  Grid,
  Menu,
  MenuItem,
  Popover,
  Typography,
  Divider,
  FormControl,
  Select,
  InputLabel,
} from '@material-ui/core';
import { createTheme, makeStyles } from '@material-ui/core/styles';

import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';

import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { ThemeProvider } from '@material-ui/styles';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import DeleteIcon from '../../assets/DeleteIcon';
// import { ReactComponent as Envelope } from '../../assets/envelope.svg';
import AddDeleteConfirmation from '../journey/AddDeleteConfirmation';
import PlanAddNewPopup from '../sidebar/PlanAddNewPopup';
import Theme from '../ui/Theme';
import {
  deleteContest,
  deleteInapp,
  deleteLeaderboard,
  deleteRule,
  getMainTabID,
  setRockedFuelSelectedSubCategory,
  showProgress,
} from '../../redux/actions/DealershipActions';

import AddDeleteConfirmationPlan from '../plan/AddDeleteConfirmationPlan';
import AddDeleteConfirmationAuthClient from '../AuthClient/AddDeleteConfirmationAuthClient';
import OtpDetailsPopup from '../dealership/OtpDetailsPopup';
import ConfigureAuthPopup from '../AuthClient/ConfigureAuthPopup';
import AddCollectionPopup from '../collections/AddCollectionPopup';
// import CollectionAddNewPopup from '../sidebar/CollectionAddNewPopup';
import ChangeOrderJourneys from '../collections/ChangeOrderJourneys';
import service from '../../apis/service';
import { ErrorToast, MultipleErrorToast, notifySuccess, formatDurationSeconds } from '../utils/Utils';
import LeaderboardDeleteConfirmation from '../leaderboard/LeaderboardDeleteConfirmation';
import InappDeleteConfirmation from '../inapp/InappDeleteConfirmation';
import CustomGroupsAddNewPopup from '../customGroups/CustomGroupsAddNewPopup';
import RuleAddNewPopup from '../rules/RulesAddNewPopup';
import DeleteConfirmationRule from '../rules/DeleteConfirmationRule';
import HandleCollectionCheckin from '../collections/HandleCollectionCheckin';
import AddTopicPopup from '../topics/AddTopicPopup';
import { apiEndpoints } from '../../constants/apiEndpoints';
import ShareGuidePopup from '../dealership/ShareGuidePopup';
import AssignJourneyPopup from '../dealership/AssignJourneyPopup';
import { AddCertPopup } from '../certification/AddCertPopup';
import { AssignCertPopup } from '../certification/AssignCertPopup';
import { InsightPopup } from '../PXDashboard/InsightPopup';
import { AddJourneysPopup } from '../collections/AddJourneysPopup';
import { ExerciseCatPopup } from '../AIRoleplay/ExerciseCatPopup';
import { useExerciseCategory } from '../AIRoleplay/hooks/useExerciseCategory';
import ContestDeleteConfirmation from '../contests/components/ContestDeleteConfirmation';
import CustomButton from '../shared/CustomButton';
import UpdateDataPopup from '../contests/components/UpdateDataPopup';
import ConfirmationDialog from '../common/ConfirmationDialog';
import JourneyAddNewPopup from '../journey/components/JourneyAddNewPopup';
import AddSeries from '../quiz/components/AddSeries';
import { DealerInviteCode } from '../dealership/InviteCodePopup';
import EditPlanDealershipPopup from '../plan/components/EditPlanDealershipPopup';
import { PLAN_MENU_OPTIONS } from './constants';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    background: theme.palette.text.secondary,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  shareBtn: {
    width: '150px',
    height: '42px',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',
    backgroundColor: Theme.palette.primary.main,
    color: Theme.palette.secondary.main,
    cursor: 'pointer',
    marginRight: '10px',
    '&:hover': {
      backgroundColor: Theme.palette.primary.main,
      color: Theme.palette.secondary.main,
    },
  },
  otpBtn: {
    width: '90px',
    height: '42px',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',
    backgroundColor: Theme.palette.secondary.main,
    cursor: 'pointer',
  },
  heading: {
    fontFamily: 'Lato',
    fontSize: '28px',
    fontWeight: 600,
    lineHeight: '39px',
    paddingTop: '30px',
    textAlign: 'left',
    maxWidth: '100%',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  deleteButton: {
    height: '35px',
    width: '45px',
    background: Theme.palette.secondary.main,
  },
  subheading: {
    fontFamily: 'Lato',
    fontSize: '12px',
    lineHeight: '15px',
    textAlign: 'left',
    marginTop: '8px',
  },
  authheading: {
    fontSize: '12px',
    lineHeight: '15px',
    textAlign: 'left',
    marginTop: '4px',
    marginBottom: '8px',
  },
  popupheading: {
    padding: theme.spacing(2),
    margin: '20px',
    marginBottom: '15px',
    paddingBottom: '0px',
  },
  textHeading: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: '4px',
  },
  popupIcon: {
    color: 'rgba(0, 0, 0, 0.4)',
    paddingRight: '0px',
  },
  popupButtonGrid: { marginBottom: '15px' },
  publishButtonPopup: {
    marginLeft: '26px',
    padding: '0px 50px',
  },
  publishCancelButton: { padding: '20px 30px', marginLeft: '0px' },
  pbottomtext: {
    marginLeft: '10px',
    marginRight: '30px',
    marginTop: '30px',
    marginBottom: '30px',
  },
  deletePopupText: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    fontStyle: 'normal',
  },
  popover: {
    pointerEvents: 'none',
  },
  paper1: {
    width: '1em',
    padding: theme.spacing(1),
  },
  customInputUnderline: {
    width: '250px',
    height: '50px',
    background: '#f5f5f6',
    borderRadius: '5px',
    padding: '0px 8px',
    textAlign: 'left',
    border: 'none',
    '&:before': {
      borderBottom: 'none !important',
    },
    '&:after': {
      borderBottom: 'none !important',
    },
  },
  viewInsight: {
    display: 'inline-block',
    marginLeft: '5px',
    fontSize: '13px',
    fontWeight: '600',
    borderBottom: '1.5px solid #622FEE',
    color: '#622FEE',
    cursor: 'pointer',
  },
  viewInviteCodeActive: {
    display: 'inline-block',
    marginLeft: '5px',
    fontSize: '13px',
    fontWeight: '600',
    borderBottom: '1.5px solid #622FEE',
    color: '#622FEE',
    cursor: 'pointer',
  },
  viewInviteCodeDisabled: {
    display: 'inline-block',
    marginLeft: '5px',
    fontSize: '13px',
    fontWeight: '600',
    borderBottom: '1.5px solid #667085',
    color: '#667085',
    cursor: 'pointer',
  },
}));

const Topbar = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [isEditJourneyPopupOpen, setEditJourneyPopupOpen] = useState(false);
  const [editCustomGroupPopup, setEditCustomGroupPopup] = useState(false);
  const [editRulePopup, setEditRulePopup] = useState(false);
  const [isEditPlanDealershipPopupOpen, setEditPlanDealershipPopupOpen] = useState(false);
  const [isEditPlanPopupOpen, setEditPlanPopupOpen] = useState(false);
  const [isEditPlanStoryPopupOpen, setEditPlanStoryPopupOpen] = useState(false);
  const [isConfigAuthPopupOpen, setConfigAuthPopupOpen] = useState(false);
  const [viewConfirmDelete, setViewConfirmDelete] = useState(false);
  const [viewConfirmDeletePlan, setViewConfirmDeletePlan] = useState(false);
  const [viewConfirmDeleteLeaderboard, setViewConfirmDeleteLeaderboard] = useState(false);
  const [viewConfirmDeleteContest, setViewConfirmDeleteContest] = useState(false);
  const [viewConfirmDeleteQuiz, setViewConfirmDeleteQuiz] = useState(false);
  const [viewConfirmDeleteInapp, setViewConfirmDeleteInapp] = useState(false);
  const [viewConfirmDeleteAuthClient, setViewConfirmDeleteAuthClient] = useState(false);
  const [viewConfirmDeleteRule, setViewConfirmDeleteRule] = useState(false);
  const [viewUpdateJourneyPopup, setViewUpdateJourneyPopup] = useState(false);
  const [viewReorderJourneyPopup, setViewReorderJourneyPopup] = useState(false);
  const [viewEditCollectionPopup, setViewEditCollectionPopup] = useState(false);
  const [viewContestUpdateDataPopup, setViewContestUpdateDataPopup] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [PanchorEl, PsetAnchorEl] = React.useState(null);
  const [UanchorEl, UsetAnchorEl] = React.useState(null);
  const [DanchorEl, DsetAnchorEl] = React.useState(null);
  const [isOpenTopicPopup, setIsOpenTopicPopup] = useState(false);
  const [isOpenShareGuide, setIsOpenShareGuide] = useState(false);
  const [isOpenAssignJourney, setIsOpenAssignJourney] = useState(false);
  const [isOpenQuizEdit, setIsOpenQuizEdit] = useState(false);
  const [isOpenCertEdit, setIsOpenCertEdit] = useState(false);
  const [isOpenExCatEdit, setIsOpenExCatEdit] = useState(false);
  const [isAssignOpen, setIsAssignOpen] = useState(false);
  const [isOpenInsight, setIsOpenInsight] = useState(false);
  const [categoryDetails, setCategoryDetails] = useState({});
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const [showInviteCode, setShowInviteCode] = useState(false);

  const popen = Boolean(PanchorEl);
  const Pid = popen ? 'simple-popover' : undefined;
  const uopen = Boolean(UanchorEl);
  const Uid = uopen ? 'simple-popover' : undefined;
  const dopen = Boolean(DanchorEl);
  const Did = dopen ? 'simple-popover' : undefined;

  const quizSeriesDetails = useSelector((state) => state?.getQuizSeries?.quizSeriesOverview);
  const collectiondetails = useSelector((state) => state.getCollection.collection);
  const roleDetails = useSelector((state) => state.rockedCurriculumData.selectedRole);
  const categorySelected = useSelector((state) => state.rockedFuelData.selectedCategory);
  const topicSelected = useSelector((state) => state.topicsData.selectedTopicInfo);
  const selectedCert = useSelector((state) => state.certificateData.selectedCert);
  const selectedCat = useSelector((state) => state.aiRoleplayData.selectedCategory || {});
  const selectedRoleplayEx = useSelector((state) => state.aiRoleplayData.exercise || {});
  const subCategorySelected = useSelector((state) => state.rockedFuelData.selectedSubCategory);
  const leaderboardDetails = useSelector((state) => state?.getLeaderboard.leaderboardOverview);
  const contestDetails = useSelector((state) => state.contestData.selectedContestDetails);
  const selectedAdmin = useSelector((state) => state.adminUsersData.selectedAdminDetails);
  const rnpDetails = useSelector((state) => state.rnpData.rnpDetails);
  const categoryId = useSelector((state) => state.categoryData.selectedId);
  const categoryList = useSelector((state) => state.categoryData.categoryList);
  const inappDetails = useSelector((state) => state.inappData.selectedInappDetails);
  const customGroupDetails = useSelector((state) => state.customGroupsData.selectedCustomGroupDetails);
  const ruleDetails = useSelector((state) => state.rulesData.selectedRuleDetails);
  const plandetails = useSelector((state) => state.getPlanDetails.plandetails);
  const planAuth = useSelector((state) => state.getPlanAuth.planAuth);
  const delaershipHeader = useSelector((state) => state.DealershipDetails.dealershipdetails);
  const mainTabID = useSelector((state) => state.getMainTabID);
  const journeyDetails = useSelector((state) => state.JourneyDetails.journeydetails);
  const levelDetails = useSelector((state) => state.getLevelDetails.leveldetails);
  const authclientdetails = useSelector((state) => state.getAuthClientDetails.authclientdetails);
  const planDetails = useSelector((state) => state.getPlanDetails.plandetails);
  const selectedPubDate = useSelector((state) => state.getSelectedPubDate);
  const selectedBadgeType = useSelector((state) => state.getSelectedBadgeType);
  const topicOfTheMonthSelectedDate = useSelector((state) => state.getTopicOfTheMonth.selectedDate);
  const selectedCertInfo = useSelector((state) => state.certificateData.selectedCertInfo);
  const inviteCode = useSelector((state) => state.DealershipDetails.dealershipdetails?.inviteCode ?? null);

  React.useEffect(() => {
    const catObj = categoryList?.find((item) => item.id === categoryId);
    setCategoryDetails(catObj);
  }, [categoryList, categoryId]);

  const { deleteCategory } = useExerciseCategory();

  // Insight
  const pxDashboardFilters = useSelector((state) => state.pxDashboardData.filters);
  const DEFAULT_FILTERS = useMemo(() => {
    const sales = pxDashboardFilters?.salesPipelineStatus?.find((i) => i.title === 'Active') || null;
    const tempAllDealerships = {};
    pxDashboardFilters?.dealerships?.forEach((i) => {
      tempAllDealerships[i.id] = i.children.map((j) => j.id);
    });

    return {
      salesPipelineStatus: sales ? [sales] : [],
      timePeriod: 0,
      source: pxDashboardFilters?.source?.map((item) => item.source) || [],
      dealerships: tempAllDealerships,
    };
  }, [pxDashboardFilters]);

  const [timePeriod, setTimePeriod] = useState(0);
  const [appliedFilters, setAppliedFilters] = useState(DEFAULT_FILTERS);
  const PERIOD_ARR = ['Last Month', 'Last Week', 'This Week', 'This Month', 'Custom Date'];
  const INSIGHT_TABS = [
    { label: `Zero Activity`, index: 0 },
    { label: `Learning Activity`, index: 1 },
    { label: `App Config`, index: 2 },
    { label: `Rewards`, index: 3 },
    { label: `Leaderboard`, index: 4 },
  ];
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDeleteCollection = async () => {
    setAnchorEl(null);
    const con = window.confirm(`Are you sure you want to delete ${collectiondetails?.title}`);
    if (con) {
      const data = JSON.stringify({
        pageIndex: 0,
        pageSize: 4,
        filters: {},
      });
      await service
        .delete(apiEndpoints.COLLECTION_REMOVE.replace('ID', collectiondetails?.id), data)
        .then(() => {
          dispatch(getMainTabID(1));
          dispatch(getMainTabID(5));
          dispatch(showProgress(false));
          notifySuccess('Deleted Successfully');
        })
        .catch((error) => {
          console.log(error);
          ErrorToast(error);
        });
    }
  };

  const handleDeleteTopic = async () => {
    setAnchorEl(null);
    dispatch(showProgress(true));
    try {
      await service.delete(apiEndpoints.TOPIC_DELETE.replace('ID', topicSelected?.id));
      notifySuccess('Topic Deleted Successfully');
      dispatch(getMainTabID(1));
      dispatch(getMainTabID(16));
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const handleTopicOverallReport = async () => {
    setAnchorEl(null);
    dispatch(showProgress(true));
    try {
      notifySuccess('Report will be sent to registered email');
      const response = await service.post(apiEndpoints.REPORT_CHECKIN_REPORT_OVERALL, { topicId: topicSelected?.id });
      notifySuccess(response.message);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const handleCloseConfirmDelete = () => {
    setViewConfirmDelete(false);
  };
  const handleCloseConfirmDeletePlan = () => {
    setViewConfirmDeletePlan(false);
  };
  const handleCloseConfirmDeleteLeaderboard = () => {
    setViewConfirmDeleteLeaderboard(false);
  };
  const handleCloseConfirmDeleteContest = () => {
    setViewConfirmDeleteContest(false);
  };
  const handleCloseConfirmDeleteQuiz = () => {
    setViewConfirmDeleteQuiz(false);
  };
  const handleCloseConfirmDeleteInapp = () => {
    setViewConfirmDeleteInapp(false);
  };
  const handleCloseConfirmDeleteAuthClient = () => {
    setViewConfirmDeleteAuthClient(false);
  };
  const handleCloseConfirmDeleteRule = () => {
    setViewConfirmDeleteRule(false);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleEditIconClick = () => {
    setAnchorEl(null);
    setEditJourneyPopupOpen(true);
  };
  const handleCustomGroupEdit = () => {
    setAnchorEl(null);
    setEditCustomGroupPopup(true);
  };
  const closeEditCustomGroup = () => {
    setEditCustomGroupPopup(false);
  };
  const handleRuleEdit = () => {
    setAnchorEl(null);
    setEditRulePopup(true);
  };
  const closeEditRule = () => {
    setEditRulePopup(false);
  };
  const handleEditPlanClick = (key) => {
    setAnchorEl(null);
    if (key === 'dealership') {
      setEditPlanDealershipPopupOpen(true);
      return;
    }
    if (key === 'journey') {
      setEditPlanPopupOpen(true);
      return;
    }
    if (key === 'story') {
      setEditPlanStoryPopupOpen(true);
      return;
    }
    if (key === 'plan') {
      setViewConfirmDeletePlan(true);
      return;
    }
    if (key === 'config') {
      setConfigAuthPopupOpen(true);
    }
  };
  const closeEditJourney = () => {
    setEditJourneyPopupOpen(false);
  };
  const closeEditPlan = () => {
    setEditPlanPopupOpen(false);
  };
  const closeEditPlanDealership = () => {
    setEditPlanDealershipPopupOpen(false);
  };
  const closeEditPlanStory = () => {
    setEditPlanStoryPopupOpen(false);
  };
  const closeConfigAuth = () => {
    setConfigAuthPopupOpen(false);
  };
  const handleClosePublish = () => {
    PsetAnchorEl(null);
  };
  const handleCloseUpdate = () => {
    UsetAnchorEl(null);
  };
  const handleCloseDelete = () => {
    DsetAnchorEl(null);
  };
  const handleOpenConfirmDelete = () => {
    setAnchorEl(null);
    setViewConfirmDelete(true);
  };
  const handleOpenConfirmDeleteLeaderboard = () => {
    setAnchorEl(null);
    setViewConfirmDeleteLeaderboard(true);
  };
  const handleOpenConfirmDeleteContest = () => {
    setAnchorEl(null);
    setViewConfirmDeleteContest(true);
  };
  const handleOpenConfirmDeleteQuiz = () => {
    setAnchorEl(null);
    setViewConfirmDeleteQuiz(true);
  };
  const handleOpenConfirmDeleteInapp = () => {
    setAnchorEl(null);
    setViewConfirmDeleteInapp(true);
  };
  const handleOpenConfirmDeleteAuthClient = () => {
    setAnchorEl(null);
    setViewConfirmDeleteAuthClient(true);
  };
  const handleOpenUpdateJourneyPopup = () => {
    setAnchorEl(null);
    setViewUpdateJourneyPopup(true);
  };
  const handleOpenReorderJourneyPopup = () => {
    setAnchorEl(null);
    if (collectiondetails?.journeys.length > 0) {
      setViewReorderJourneyPopup(true);
    } else {
      const errors = [];
      errors.push('Please add journeys to collection.');
      MultipleErrorToast(errors);
    }
  };
  const handleOpenConfirmDeleteRule = () => {
    setAnchorEl(null);
    setViewConfirmDeleteRule(true);
  };
  const handleOpenEditCollection = () => {
    setAnchorEl(null);
    setViewEditCollectionPopup(true);
  };
  const handleCloseEditCollection = () => {
    setAnchorEl(null);
    setViewEditCollectionPopup(false);
  };
  const handleContestUpdateData = () => {
    setAnchorEl(null);
    setViewContestUpdateDataPopup((prev) => !prev);
  };
  const handleCloseUpdateJourneyPopup = () => {
    setViewUpdateJourneyPopup(false);
  };
  const handleCloseReorderJourneyPopup = () => {
    setViewReorderJourneyPopup(false);
  };
  const nth = (d) => {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };
  const handleDeletePlan = async () => {
    dispatch(showProgress(true));
    const { id } = plandetails;
    const data = JSON.stringify({
      title: plandetails.title,
    });
    await service
      .delete(apiEndpoints.PLAN_BY_ID.replace('ID', id), data)
      .then(() => {
        dispatch(getMainTabID(1));
        dispatch(getMainTabID(3));
        dispatch(showProgress(false));
        notifySuccess('Deleted Successfully');
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };
  const handleDeleteLeaderboard = async () => {
    dispatch(showProgress(true));
    const { id } = leaderboardDetails;
    await service
      .delete(apiEndpoints.LB_BY_ID.replace('LB_ID', id))
      .then(() => {
        dispatch(deleteContest(id));
        dispatch(getMainTabID(1));
        dispatch(getMainTabID(8));
        dispatch(showProgress(false));
        notifySuccess('Deleted Successfully');
      })
      .catch((error) => {
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };
  const handleDeleteContest = async () => {
    dispatch(showProgress(true));
    const { id } = contestDetails;
    await service
      .delete(apiEndpoints.CON_BY_ID.replace('ID', id))
      .then(() => {
        dispatch(deleteLeaderboard(id));
        dispatch(getMainTabID(1));
        dispatch(getMainTabID(19));
        dispatch(showProgress(false));
        notifySuccess('Deleted Successfully');
      })
      .catch((error) => {
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };
  const handleDeleteQuiz = async () => {
    dispatch(showProgress(true));
    const { id } = quizSeriesDetails;
    await service
      .delete(apiEndpoints.QUIZ_SERIES_BY_ID.replace('ID', id))
      .then(() => {
        dispatch(getMainTabID(1));
        dispatch(getMainTabID(22));
        dispatch(showProgress(false));
        notifySuccess('Deleted Successfully');
        setViewConfirmDeleteQuiz(false);
      })
      .catch((error) => {
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };
  const handleDeleteInapp = async () => {
    dispatch(showProgress(true));
    const { id } = inappDetails;
    await service
      .delete(apiEndpoints.INAPP_UPDATE.replace('INAPP_ID', id))
      .then(() => {
        dispatch(deleteInapp(id));
        dispatch(getMainTabID(1));
        dispatch(getMainTabID(9));
        dispatch(showProgress(false));
        notifySuccess('Deleted Successfully');
      })
      .catch((error) => {
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };
  const handleDeleteAuthClient = async () => {
    dispatch(showProgress(true));
    const { id } = authclientdetails;

    await service
      .delete(apiEndpoints.AUTH_UPDATE_AUTHENTICATION.replace('AUTH_CLIENT_ID', id))
      .then(() => {
        dispatch(getMainTabID(1));
        dispatch(getMainTabID(6));
        dispatch(showProgress(false));
        notifySuccess('Deleted Successfully');
      })
      .catch((error) => {
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };
  const handleDeleteRule = async () => {
    dispatch(showProgress(true));
    await service
      .delete(apiEndpoints.RULE_REMOVE.replace('ID', ruleDetails.id))
      .then(() => {
        dispatch(deleteRule(ruleDetails.id));
        dispatch(getMainTabID(1));
        dispatch(getMainTabID(11));
        dispatch(showProgress(false));
        notifySuccess('Deleted Successfully');
      })
      .catch((error) => {
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };
  const showOtpDetails = () => {
    setShowOtpModal(true);
  };
  const closeOtpDetails = () => {
    setShowOtpModal(false);
  };
  const handleDeleteJourney = async () => {
    dispatch(showProgress(true));
    await service
      .delete(apiEndpoints.JOURNEY_BY_ID.replace('ID', journeyDetails.id))
      .then(() => {
        handleCloseConfirmDelete();
        notifySuccess('Deleted Successfully');
        dispatch(getMainTabID(1));
        dispatch(getMainTabID(0));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        handleCloseConfirmDelete();
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };

  const handleConfirm = () => {
    setIsConfirmDelete(true);
    setAnchorEl(null);
  };

  const handleCertDelete = async () => {
    setAnchorEl(null);
    dispatch(showProgress(true));
    try {
      await service.delete(apiEndpoints.CERT_DELETE.replace('ID', selectedCertInfo.id));
      setIsConfirmDelete(false);
      notifySuccess('Certification deleted successfully');
      dispatch(getMainTabID(1));
      dispatch(getMainTabID(17));
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const handleInviteCodeClick = () => {
    if (inviteCode) {
      setShowInviteCode(true);
    } else {
      ErrorToast('Dealer Invite Code not configured. Contact RockED Support');
    }
  };

  const dateVal = new Date(selectedPubDate?.replace(/-/g, '/'));
  const date = dateVal.getDate();
  const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][
    dateVal.getMonth()
  ];
  const ordinal = selectedPubDate ? `${date}${nth(date)} ${month} ${dateVal.getFullYear()}` : '';
  const getTitle = () => {
    if (mainTabID === 1 && delaershipHeader !== undefined) {
      return delaershipHeader.name;
    }
    if (mainTabID === 0 && journeyDetails !== undefined) {
      return journeyDetails.title;
    }
    if (mainTabID === 3 && planDetails !== undefined) {
      return planDetails.title;
    }
    if (mainTabID === 7) {
      return `${selectedBadgeType.charAt(0).toUpperCase() + selectedBadgeType.slice(1)} Badges`;
    }
    if (mainTabID === 6) {
      return `${authclientdetails?.name || ''}`;
    }
    if (mainTabID === 5) {
      return `${collectiondetails?.title || ''}`;
    }
    if (mainTabID === 8) {
      return `${leaderboardDetails?.name || ''}`;
    }
    if (mainTabID === 9) {
      return `${inappDetails?.title || ''}`;
    }
    if (mainTabID === 10) {
      return `${customGroupDetails?.name || ''}`;
    }
    if (mainTabID === 11) {
      return `${ruleDetails?.name || ''}`;
    }
    if (mainTabID === 12) {
      return `${topicOfTheMonthSelectedDate?.title || ''}`;
    }
    if (mainTabID === 14) {
      return `${roleDetails?.title || ''}`;
    }
    if (mainTabID === 15) {
      return `${subCategorySelected.title || ''}`;
    }
    if (mainTabID === 16) {
      return `${topicSelected?.title || ''}`;
    }
    if (mainTabID === 17) {
      return `${selectedCert?.name || ''} `;
    }
    if (mainTabID === 18) {
      return `${selectedCat?.name || ''}`;
    }
    if (mainTabID === 19) {
      return `${contestDetails?.name || ''}`;
    }
    if (mainTabID === 20) {
      return `${categoryDetails?.title || ''}`;
    }
    if (mainTabID === 21) {
      return `${rnpDetails?.type || ''}`;
    }
    if (mainTabID === 22) {
      return `${quizSeriesDetails?.name || ''}`;
    }
    if (mainTabID === 23) {
      return `${selectedAdmin?.firstName || ''} ${selectedAdmin?.lastName || ''}`.trim();
    }
    return '';
  };
  const getSubtitle = () => {
    if (mainTabID === 1) {
      return '';
    }
    if (mainTabID === 0 && journeyDetails) {
      const learningUnits = journeyDetails?.luCount ?? 0;
      const journeyDuration = journeyDetails?.journeyDuration ?? 0;
      const capstoneCount = journeyDetails?.capstoneActivitiesCount ?? 0;
      if (levelDetails) {
        return `${learningUnits} Learning units | ${formatDurationSeconds(
          journeyDuration,
        )} | ${capstoneCount} Capstone Activities`;
      }
    }
    if (mainTabID === 2) {
      return 'Last Updated 2 hrs ago';
    }
    if (mainTabID === 3) {
      return `Plan ID: ${plandetails?.id}`;
    }
    if (mainTabID === 19) {
      return `50 Collections`;
    }
    if (mainTabID === 22) {
      return `Plans: ${quizSeriesDetails?.planCount ?? 0}, Roles:  ${
        quizSeriesDetails?.departmentRoleCount ?? 0
      }, ID: ${quizSeriesDetails?.id ?? ''}`;
    }
    return '';
  };
  const showID = () => {
    if (mainTabID === 0 && journeyDetails !== undefined) {
      return `Journey ID: ${journeyDetails.id}`;
    }
    if (mainTabID === 1) {
      return (
        <Grid container spacing={1}>
          <Grid item>
            Dealership ID: {delaershipHeader?.id}, Source: {delaershipHeader?.source}{' '}
            <Typography className={classes.viewInsight} onClick={() => setIsOpenInsight(true)}>
              View Insight
            </Typography>
          </Grid>
          <Grid item onClick={handleInviteCodeClick}>
            <Typography className={inviteCode ? classes.viewInviteCodeActive : classes.viewInviteCodeDisabled}>
              View Invite Code
            </Typography>
          </Grid>
        </Grid>
      );
    }
    if (mainTabID === 3) {
      return `Auth Configured: ${planAuth}`;
    }
    if (mainTabID === 5) {
      return `Collection ID: ${collectiondetails?.id}`;
    }
    if (mainTabID === 8) {
      return `Leaderboard ID: ${leaderboardDetails?.id}`;
    }
    if (mainTabID === 9) {
      return `Inapp ID: ${inappDetails?.id}`;
    }
    if (mainTabID === 10) {
      return `Custom Group ID: ${customGroupDetails?.id}`;
    }
    if (mainTabID === 11) {
      return `Rule ID: ${ruleDetails?.id}`;
    }
    if (mainTabID === 14) {
      return `Department: ${roleDetails?.department?.title}`;
    }
    if (mainTabID === 15) {
      return `Category: ${categorySelected?.title}`;
    }
    if (mainTabID === 16) {
      return `Topic ID: ${topicSelected.id}, Created By: ${topicSelected.createdBy}, Created On: ${moment(
        topicSelected.createdAt,
      ).format('DD-MM-YY')}`;
    }
    if (mainTabID === 17) {
      return `Certification ID: ${selectedCert?.id}`;
    }
    if (mainTabID === 18) {
      return `Exercise Category ID: ${selectedCat?.id}`;
    }
    if (mainTabID === 19) {
      return `Contest ID: ${contestDetails?.id}`;
    }
    if (mainTabID === 20) {
      return `${categoryDetails?.collectionCount || 0} Collections`;
    }
    if (mainTabID === 21) {
      return `${rnpDetails?.partners?.length || 0} ${rnpDetails?.partners?.length > 1 ? 'RNPs' : 'RNP'}`;
    }
    if (mainTabID === 23) {
      return selectedAdmin?.id ? `Admin #${selectedAdmin.id}` : '';
    }
    return ' ';
  };

  const handleSubCatChange = (value) => {
    dispatch(setRockedFuelSelectedSubCategory(value));
  };
  const handleDeleteExCat = () => {
    if (selectedCat?.exerciseCount) {
      ErrorToast('You cannot the delete the category when exercises are present.');
      return;
    }
    deleteCategory();
    setAnchorEl(null);
  };
  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item style={{ width: '70%', marginBottom: '10px' }}>
          <Grid item className={classes.heading}>
            {getTitle()}
            {mainTabID === 2 ? ordinal : ''}
          </Grid>
          <Grid item>
            <Grid
              container
              direction="column"
              justifyContent="flext-start"
              alignItems="flex-start"
              style={{ width: '70%' }}
            >
              <Grid item className={classes.subheading}>
                {getSubtitle()}
              </Grid>
              <Grid item className={classes.subheading}>
                {showID()}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ width: '30%', display: 'flex', justifyContent: 'flex-end' }}>
          {mainTabID === 0 ? (
            <Grid container justify="flex-end" alignItems="center">
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  className={classes.deleteButton}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreHorizIcon />
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  style={{
                    marginTop: '5.5vh',
                  }}
                >
                  <MenuItem value="Edit Journey" className={classes.menuRoot} onClick={handleEditIconClick}>
                    Edit Journey
                  </MenuItem>
                  <MenuItem
                    value="Copy Journey Scheme Deeplink"
                    className={classes.menuRoot}
                    onClick={() => {
                      navigator.clipboard.writeText(journeyDetails.schemeDeeplink);
                      notifySuccess('Journey Scheme Deeplink Copied');
                    }}
                  >
                    Copy Scheme Deeplink
                  </MenuItem>
                  <MenuItem
                    value="Copy Journey Universal Deeplink"
                    className={classes.menuRoot}
                    onClick={() => {
                      navigator.clipboard.writeText(journeyDetails.universalDeeplink);
                      notifySuccess('Journey Universal Deeplink Copied');
                    }}
                  >
                    Copy Universal Deeplink
                  </MenuItem>
                  <MenuItem value="Delete Journey" className={classes.menuRoot} onClick={handleOpenConfirmDelete}>
                    Delete Journey
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          ) : null}
          {mainTabID === 1 ? (
            <>
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  className={classes.shareBtn}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  Share & Assign
                </Button>
                <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                  <MenuItem
                    className={classes.menuRoot}
                    onClick={() => {
                      setIsOpenShareGuide(true);
                      handleClose();
                    }}
                  >
                    Share Guide
                  </MenuItem>
                  <MenuItem
                    className={classes.menuRoot}
                    onClick={() => {
                      setIsOpenAssignJourney(true);
                      handleClose();
                    }}
                  >
                    Assign Journey
                  </MenuItem>
                </Menu>
              </Grid>
              <Button
                className={classes.otpBtn}
                onClick={() => {
                  showOtpDetails();
                }}
              >
                View OTP
              </Button>
            </>
          ) : null}
          {mainTabID === 3 ? (
            <Grid container justify="flex-end" alignItems="center">
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  className={classes.deleteButton}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreHorizIcon />
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  style={{
                    marginTop: '5.5vh',
                  }}
                >
                  {PLAN_MENU_OPTIONS.map((option) => (
                    <MenuItem key={option.key} className={classes.menuRoot} onClick={() => handleEditPlanClick(option.key)}>
                      {option.value}
                    </MenuItem>
                  ))}
                </Menu>
              </Grid>
            </Grid>
          ) : null}
          {mainTabID === 6 ? (
            <Grid container justify="flex-end" alignItems="center">
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  className={classes.deleteButton}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreHorizIcon />
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  style={{
                    marginTop: '5.5vh',
                  }}
                >
                  <MenuItem value="Delete" className={classes.menuRoot} onClick={handleOpenConfirmDeleteAuthClient}>
                    Delete
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          ) : null}
          {mainTabID === 5 ? (
            <Grid container justify="flex-end" alignItems="center">
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  className={classes.deleteButton}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreHorizIcon />
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  style={{
                    marginTop: '5.5vh',
                  }}
                >
                  {!collectiondetails?.updateJourneyDisabled && (
                    <MenuItem value="Update" className={classes.menuRoot} onClick={handleOpenUpdateJourneyPopup}>
                      Update Journeys
                    </MenuItem>
                  )}
                  <MenuItem value="Reorder" className={classes.menuRoot} onClick={handleOpenReorderJourneyPopup}>
                    Re-order Journeys
                  </MenuItem>
                  <MenuItem
                    value="Copy Scheme Collection Deeplink"
                    className={classes.menuRoot}
                    onClick={() => {
                      navigator.clipboard.writeText(collectiondetails.schemeDeeplink);
                      notifySuccess('Collection Scheme Deeplink Copied');
                    }}
                  >
                    Copy Scheme Deeplink
                  </MenuItem>
                  <MenuItem
                    value="Copy Universal Collection Deeplink"
                    className={classes.menuRoot}
                    onClick={() => {
                      navigator.clipboard.writeText(collectiondetails.universalDeeplink);
                      notifySuccess('Collection Universal Deeplink Copied');
                    }}
                  >
                    Copy Universal Deeplink
                  </MenuItem>
                  <MenuItem value="Edit" className={classes.menuRoot} onClick={handleOpenEditCollection}>
                    Edit Collection
                  </MenuItem>
                  <MenuItem value="Delete" className={classes.menuRoot} onClick={handleDeleteCollection}>
                    Delete Collection
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          ) : null}
          {mainTabID === 8 ? (
            <Grid container justify="flex-end" alignItems="center">
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  className={classes.deleteButton}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreHorizIcon />
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  style={{
                    marginTop: '5.5vh',
                  }}
                >
                  <MenuItem value="Delete" className={classes.menuRoot} onClick={handleOpenConfirmDeleteLeaderboard}>
                    Delete
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          ) : null}
          {mainTabID === 9 ? (
            <Grid container justify="flex-end" alignItems="center">
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  className={classes.deleteButton}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreHorizIcon />
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  style={{
                    marginTop: '5.5vh',
                  }}
                >
                  <MenuItem value="Delete" className={classes.menuRoot} onClick={handleOpenConfirmDeleteInapp}>
                    Delete
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          ) : null}
          {mainTabID === 10 ? (
            <Grid container justify="flex-end" alignItems="center">
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  className={classes.deleteButton}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreHorizIcon />
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  style={{
                    marginTop: '5.5vh',
                  }}
                >
                  <MenuItem value="Edit" className={classes.menuRoot} onClick={handleCustomGroupEdit}>
                    Edit
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          ) : null}
          {mainTabID === 11 ? (
            <Grid container justify="flex-end" alignItems="center">
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  className={classes.deleteButton}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreHorizIcon />
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  style={{
                    marginTop: '5.5vh',
                  }}
                >
                  <MenuItem value="Edit" className={classes.menuRoot} onClick={handleRuleEdit}>
                    Edit Rule
                  </MenuItem>
                  <MenuItem value="Delete" className={classes.menuRoot} onClick={handleOpenConfirmDeleteRule}>
                    Delete Rule
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          ) : null}
          {mainTabID === 15 ? (
            <Grid>
              <FormControl>
                <InputLabel>Select Subcategory:</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={subCategorySelected}
                  renderValue={(value) => value?.title}
                  onChange={(e) => handleSubCatChange(e.target.value)}
                  className={classes.customInputUnderline}
                >
                  {categorySelected?.fuelSubCategories?.map((item) => (
                    <MenuItem style={{ textAlign: 'left' }} key={item.id} value={item}>
                      {item.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          ) : null}
          {mainTabID === 16 ? (
            <Grid container justify="flex-end" alignItems="center">
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  className={classes.deleteButton}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreHorizIcon />
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  style={{
                    marginTop: '5.5vh',
                  }}
                >
                  <MenuItem
                    value="Edit"
                    className={classes.menuRoot}
                    onClick={() => {
                      setIsOpenTopicPopup(true);
                      setAnchorEl(null);
                    }}
                  >
                    Edit Topic
                  </MenuItem>
                  <MenuItem value="Delete" className={classes.menuRoot} onClick={handleTopicOverallReport}>
                    Overall Report
                  </MenuItem>
                  <MenuItem value="Delete" className={classes.menuRoot} onClick={handleDeleteTopic}>
                    Delete Topic
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          ) : null}
          {mainTabID === 17 ? (
            <Grid container justify="flex-end" alignItems="center" style={{ gap: '10px' }}>
              <Button
                style={{ background: '#622FEE', color: '#fff', height: '35px', width: '80px', cursor: 'pointer' }}
                onClick={() => {
                  if (selectedCertInfo?.exam?.id) {
                    setIsAssignOpen(true);
                  } else {
                    ErrorToast('Add an exam to assign a certification');
                  }
                }}
              >
                Assign
              </Button>
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  className={classes.deleteButton}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreHorizIcon />
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  style={{
                    marginTop: '5.5vh',
                  }}
                >
                  <MenuItem
                    style={{ justifyContent: 'left' }}
                    value="Copy Guide Scheme Deeplink"
                    className={classes.menuRoot}
                    onClick={() => {
                      navigator.clipboard.writeText(selectedCertInfo.schemeDeeplink);
                      notifySuccess('Certification Scheme Deeplink Copied');
                    }}
                  >
                    Copy Scheme Deeplink
                  </MenuItem>
                  <MenuItem
                    style={{ justifyContent: 'left' }}
                    value="Copy Guide Scheme Deeplink"
                    className={classes.menuRoot}
                    onClick={() => {
                      navigator.clipboard.writeText(selectedCertInfo.universalDeeplink);
                      notifySuccess('Certification Scheme Deeplink Copied');
                    }}
                  >
                    Copy Universal Deeplink
                  </MenuItem>
                  <MenuItem
                    value="Edit"
                    className={classes.menuRoot}
                    onClick={() => {
                      setIsOpenCertEdit(true);
                      setAnchorEl(null);
                    }}
                  >
                    Edit Certification
                  </MenuItem>
                  {/* <MenuItem value="Delete" className={classes.menuRoot}>
                    Overall Report
                  </MenuItem> */}
                  <MenuItem value="Delete" className={classes.menuRoot} onClick={handleConfirm}>
                    Delete Certification
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          ) : null}
          {mainTabID === 18 ? (
            <Grid container justify="flex-end" alignItems="center" style={{ gap: '10px' }}>
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  className={classes.deleteButton}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreHorizIcon />
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  style={{
                    marginTop: '5.5vh',
                  }}
                >
                  <MenuItem
                    value="Copy Exercise Scheme Deeplink"
                    onClick={() => {
                      navigator.clipboard.writeText(selectedRoleplayEx?.schemeDeeplink);
                      notifySuccess('Exercise Scheme Deeplink Copied');
                    }}
                  >
                    Copy Scheme Deeplink
                  </MenuItem>
                  <MenuItem
                    value="Copy Exercise Universal Deeplink"
                    onClick={() => {
                      navigator.clipboard.writeText(selectedRoleplayEx?.universalDeeplink);
                      notifySuccess('Exercise Universal Deeplink Copied');
                    }}
                  >
                    Copy Universal Deeplink
                  </MenuItem>
                  <MenuItem
                    value="Edit"
                    className={classes.menuRoot}
                    onClick={() => {
                      setAnchorEl(null);
                      setIsOpenExCatEdit(true);
                    }}
                  >
                    Edit Exercise Category
                  </MenuItem>
                  <MenuItem value="Delete" className={classes.menuRoot} onClick={handleDeleteExCat}>
                    Delete Exercise Category
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          ) : null}
          {mainTabID === 19 ? (
            <Grid container justify="flex-end" alignItems="center">
              {contestDetails?.category === 'IMPORT' && (
                <Grid item style={{ marginRight: '8px' }}>
                  <CustomButton size="small" label="Update" type="primary" onClick={handleContestUpdateData} />
                </Grid>
              )}
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  className={classes.deleteButton}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreHorizIcon />
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  style={{
                    marginTop: '5.5vh',
                  }}
                >
                  <MenuItem value="Delete" className={classes.menuRoot} onClick={handleOpenConfirmDeleteContest}>
                    Delete
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          ) : null}
          {mainTabID === 22 ? (
            <Grid container justify="flex-end" alignItems="center">
              <Grid item style={{ marginRight: '8px' }}>
                {/* <CustomButton icon={<Envelope />} label="Email Series Summary" type="secondary" size="small" /> */}
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  focusRipple={false}
                  disableElevation
                  className={classes.deleteButton}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreHorizIcon />
                </Button>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  style={{
                    marginTop: '5.5vh',
                  }}
                >
                  <MenuItem
                    value="Copy Quiz Scheme Deeplink"
                    className={classes.menuRoot}
                    onClick={() => {
                      navigator.clipboard.writeText(quizSeriesDetails.schemeDeeplink);
                      notifySuccess('Quiz Scheme Deeplink Copied');
                    }}
                  >
                    Copy Scheme deeplink
                  </MenuItem>
                  <MenuItem
                    value="Copy Quiz Universal Deeplink"
                    className={classes.menuRoot}
                    onClick={() => {
                      navigator.clipboard.writeText(quizSeriesDetails.universalDeeplink);
                      notifySuccess('Quiz Universal Deeplink Copied');
                    }}
                  >
                    Copy Universal deepLink
                  </MenuItem>
                  <MenuItem
                    value="Edit"
                    className={classes.menuRoot}
                    onClick={() => {
                      setIsOpenQuizEdit(true);
                      setAnchorEl(null);
                    }}
                  >
                    Edit Quiz Series
                  </MenuItem>
                  <MenuItem value="Delete" className={classes.menuRoot} onClick={handleOpenConfirmDeleteQuiz}>
                    Delete Quiz Series
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          ) : null}
        </Grid>
      </Grid>

      {isEditPlanDealershipPopupOpen && <EditPlanDealershipPopup close={closeEditPlanDealership} />}
      {isEditPlanPopupOpen && <PlanAddNewPopup open close={closeEditPlan} add={false} type="Journey" />}
      {isEditPlanStoryPopupOpen && <PlanAddNewPopup open close={closeEditPlanStory} add={false} type="Story" />}
      {isConfigAuthPopupOpen && <ConfigureAuthPopup open close={closeConfigAuth} />}
      {isEditJourneyPopupOpen && (
        <JourneyAddNewPopup open close={closeEditJourney} add={false} journeyId={journeyDetails?.id} />
      )}
      {editCustomGroupPopup && (
        <CustomGroupsAddNewPopup close={closeEditCustomGroup} edit selectedData={customGroupDetails} />
      )}
      {editRulePopup && <RuleAddNewPopup close={closeEditRule} edit selectedData={ruleDetails} />}
      <Popover
        id={Pid}
        open={popen}
        anchorEl={PanchorEl}
        onClose={handleClosePublish}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Grid container justifyContent="flex-start" alignItems="center" className={classes.popupheading}>
          <Grid item xs={1}>
            <ErrorOutlineOutlinedIcon className={classes.popupIcon} />
          </Grid>
          <Grid itemxs={10} className={classes.textHeading}>
            32 Changes since last update
          </Grid>
        </Grid>

        <Grid container justifyContent="center" alignItems="center" className={classes.popupButtonGrid}>
          <Grid item xs={8}>
            <Button variant="contained" color="primary" className={classes.publishButtonPopup}>
              Publish Changes
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button variant="contained" className={classes.publishCancelButton} onClick={handleClosePublish}>
              Cancel
            </Button>
          </Grid>
        </Grid>

        <Divider />
        <Typography className={classes.pbottomtext}>Last Published on 3 hrs ago</Typography>
      </Popover>

      <Popover
        id={Uid}
        open={uopen}
        anchorEl={UanchorEl}
        onClose={handleCloseUpdate}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Grid container justifyContent="flex-start" alignItems="center" className={classes.popupheading}>
          <Grid item xs={1}>
            <ErrorOutlineOutlinedIcon className={classes.popupIcon} />
          </Grid>
          <Grid itemxs={10} className={classes.textHeading}>
            32 Changes since last update
          </Grid>
        </Grid>

        <Grid container justifyContent="center" alignItems="center" className={classes.popupButtonGrid}>
          <Grid item xs={8}>
            <Button variant="contained" color="primary" className={classes.publishButtonPopup}>
              Update Changes
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button variant="contained" className={classes.publishCancelButton} onClick={handleClosePublish}>
              Cancel
            </Button>
          </Grid>
        </Grid>

        <Divider />
        <Typography className={classes.pbottomtext}>Last Published on 3 hrs ago</Typography>
      </Popover>

      <ThemeProvider
        theme={(theme) =>
          createTheme({
            ...theme,
            overrides: {
              MuiPopover: {
                paper: {
                  minWidth: '7em',
                  maxWidth: '50em',
                },
              },
              MuiPaper: {
                rounded: {
                  borderRadius: '0',
                },
              },
            },
          })
        }
      >
        <Popover
          id={Did}
          open={dopen}
          anchorEl={DanchorEl}
          classes={{
            paper: classes.paper,
          }}
          onClose={handleCloseDelete}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          style={{ cursor: 'pointer' }}
        >
          <Typography className={classes.deletePopupText} onClick={handleOpenConfirmDelete}>
            Delete Journey
          </Typography>
        </Popover>
        {viewConfirmDelete && (
          <AddDeleteConfirmation open close={handleCloseConfirmDelete} delFn={handleDeleteJourney} />
        )}
        {viewConfirmDeletePlan && (
          <AddDeleteConfirmationPlan open close={handleCloseConfirmDeletePlan} delFn={handleDeletePlan} />
        )}
        {viewConfirmDeleteLeaderboard && (
          <LeaderboardDeleteConfirmation
            open
            close={handleCloseConfirmDeleteLeaderboard}
            delFn={handleDeleteLeaderboard}
          />
        )}
        {viewConfirmDeleteContest && (
          <ContestDeleteConfirmation open close={handleCloseConfirmDeleteContest} delFn={handleDeleteContest} />
        )}
        {viewConfirmDeleteQuiz && (
          <ConfirmationDialog
            title="Are you sure you want to delete this Quiz Series?"
            subText="Once you delete it, you will not be able to recover it."
            onClose={handleCloseConfirmDeleteQuiz}
            isOpen={viewConfirmDeleteQuiz}
            confirmFn={handleDeleteQuiz}
            disagreeText="Cancel"
            agreeText="Delete"
            Icon={DeleteIcon}
            width="335px"
            height="229px"
          />
        )}
        {viewConfirmDeleteInapp && (
          <InappDeleteConfirmation open close={handleCloseConfirmDeleteInapp} delFn={handleDeleteInapp} />
        )}
        {viewConfirmDeleteAuthClient && (
          <AddDeleteConfirmationAuthClient
            open
            close={handleCloseConfirmDeleteAuthClient}
            delFn={handleDeleteAuthClient}
          />
        )}
        {viewConfirmDeleteRule && (
          <DeleteConfirmationRule
            open
            close={handleCloseConfirmDeleteRule}
            delFn={handleDeleteRule}
            journeyCount={ruleDetails.journeys?.length}
          />
        )}
        <ConfirmationDialog
          title="Are you sure you want to delete the certification?"
          subText="Once you delete it, you will not be able to recover it."
          onClose={setIsConfirmDelete}
          isOpen={isConfirmDelete}
          confirmFn={handleCertDelete}
          disagreeText="Cancel"
          agreeText="Delete"
          Icon={DeleteIcon}
          width="500px"
          height="260px"
        />
        {viewUpdateJourneyPopup && !collectiondetails?.preAssessmentId && !collectiondetails?.postAssessmentId && (
          <AddCollectionPopup id={collectiondetails?.id} edit close={handleCloseUpdateJourneyPopup} />
        )}

        {viewUpdateJourneyPopup && (collectiondetails?.preAssessmentId || collectiondetails?.postAssessmentId) && (
          <AddJourneysPopup setIsOpen={setViewUpdateJourneyPopup} isOpen={viewUpdateJourneyPopup} />
        )}

        {viewReorderJourneyPopup && (
          <ChangeOrderJourneys id={collectiondetails?.id} open close={handleCloseReorderJourneyPopup} />
        )}
        {viewEditCollectionPopup && (
          <HandleCollectionCheckin open close={handleCloseEditCollection} mode="edit" id={collectiondetails?.id} />
        )}
        {viewContestUpdateDataPopup && <UpdateDataPopup open close={handleContestUpdateData} />}
        {showOtpModal && <OtpDetailsPopup close={closeOtpDetails} />}
        {isOpenTopicPopup && <AddTopicPopup isOpen={isOpenTopicPopup} setIsOpen={setIsOpenTopicPopup} isEdit />}
        {isOpenShareGuide && <ShareGuidePopup isOpen={isOpenShareGuide} setIsOpen={setIsOpenShareGuide} />}
        {isOpenAssignJourney && <AssignJourneyPopup isOpen={isOpenAssignJourney} setIsOpen={setIsOpenAssignJourney} />}
        {isOpenCertEdit && (
          <AddCertPopup isEdit={isOpenCertEdit} isOpenAddCert={isOpenCertEdit} setIsOpenAddCert={setIsOpenCertEdit} />
        )}
        {isOpenQuizEdit && <AddSeries isOpen close={() => setIsOpenQuizEdit(false)} seriesId={quizSeriesDetails?.id} />}
        {isOpenExCatEdit && (
          <ExerciseCatPopup isEdit={isOpenExCatEdit} isOpen={isOpenExCatEdit} setIsOpen={setIsOpenExCatEdit} />
        )}
        {isAssignOpen && <AssignCertPopup isAssignOpen={isAssignOpen} setIsAssignOpen={setIsAssignOpen} />}
        {isOpenInsight && (
          <InsightPopup
            setOpenInsightPopup={setIsOpenInsight}
            PERIOD_ARR={PERIOD_ARR}
            INSIGHT_TABS={INSIGHT_TABS}
            timePeriod={timePeriod}
            setTimePeriod={setTimePeriod}
            selctedDealerId={delaershipHeader?.id}
            appliedFilters={appliedFilters}
            setAppliedFilters={setAppliedFilters}
          />
        )}
        {showInviteCode && (
          <DealerInviteCode onClose={() => setShowInviteCode(false)} isOpen={showInviteCode} inviteCode={inviteCode} />
        )}
      </ThemeProvider>
    </>
  );
};
export default Topbar;
